import { VALUE_TYPES } from "@/static/valueTypes";
import { Expose, Type } from "class-transformer";
import { IsArray, IsBoolean, IsEnum, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
import GenericTableResponse from "@/models/api/GenericTableResponse";
import { Translation } from "@/models/api/Translation";

export class AttributePrototype {
  @Expose()
  @IsNumber()
  id!: number;
  @Expose()
  @IsEnum(VALUE_TYPES)
  defaultValueType!: VALUE_TYPES;
  @Expose()
  @IsOptional()
  @IsString()
  defaultLabel!: string | null;
  @Expose()
  @IsBoolean()
  isLocked!: boolean;
  @Expose()
  @IsNumber()
  recordStampId!: number;
  @Expose()
  @IsString()
  code!: string;
  @Expose()
  @IsString()
  translateDefaultValueType!: string;
  @Expose()
  @IsOptional()
  @IsString()
  attributeSource!: null | string;
  @Expose()
  @IsBoolean()
  canDelete!: boolean;
  @Expose()
  @IsBoolean()
  valueToUpper!: boolean;

  @Expose()
  @IsArray()
  @Type(() => Translation)
  @ValidateNested()
  attributeTranslations!: Array<Translation>;
}

export class AttributePrototypesResponse extends GenericTableResponse<AttributePrototype> {
  @Expose()
  @IsArray()
  @Type(() => AttributePrototype)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<AttributePrototype>;
}
